import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blogCategorySlider() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.blog__category__splide');
        let blogSearch = document.querySelector('.blog__search');
        
        let disableFunctionForMobile = false;
      
        blocks.forEach(block=>{
            new Splide(block, {
                cover: true,
                perPage: 8,
                perMove: 1,
                autoWidth: true,
                breakpoints: {
                    991: {
                      perPage: 4,
                      drag: true,
                    },
                    767: {
                      perPage: 2,
                  
                    },
                  },
              }).mount();
        })
        let searchButton = document.querySelectorAll('.blog__search.searchBox .searchBox__icon');
        let formSearch = document.getElementById('searchform');
        let searchInputValue = formSearch.querySelectorAll('input[type="text"]');
        let searchFormClose = document.querySelectorAll('.blog__search.searchBox .searchBox__close');
        function getValueFromSearchForm(){
            searchInputValue.forEach((singleInput)=>{
                singleInput.classList.remove('input--error');
                if(singleInput.value.length >= 3){
                    formSearch.submit();
                }else{
                    singleInput.classList.add('input--error')
                }
            })
        }
        searchButton.forEach((button)=>{
            button.addEventListener('click', ()=>{
                if(button.parentElement.classList.contains('active')){
                    getValueFromSearchForm();
                }else{
                    button.parentElement.classList.add('active');
                    if(disableFunctionForMobile){
                        blogSearch.classList.add('mobile');
                    }
                }
            })
        })
        searchFormClose.forEach((closeButton)=>{
            closeButton.addEventListener('click',()=>{
                closeButton.parentElement.classList.remove('active');
            })
        })
        function setWindowSize() {
            if (typeof (window.innerWidth) == 'number') {
              myWidth = window.innerWidth;
            } else {
              if (document.documentElement && document.documentElement.clientWidth ) {
                myWidth = document.documentElement.clientWidth;
              } else {
                if (document.body && document.body.clientWidth) {
                  myWidth = document.body.clientWidth;
                }
              }
            }
            if(document.querySelector('.blog__category')){
                if(myWidth <= windowBreakPoints){
                    disableFunctionForMobile = true;
                    let blogSearch = document.querySelector('.blog__search');
                    blogSearch.classList.add('active');
                }
            }
            if(document.querySelector('.blockFourColumnTextIcon')){
               if(myWidth <= 767){
                 console.log('myWidth',myWidth)
                 console.log('windowBreakPoints',windowBreakPoints)
                document.addEventListener( 'DOMContentLoaded', function () {
                  blockFourColumnTextIconScript();
                });
               }
            }
        } 
        window.addEventListener('resize', setWindowSize);
       
    })
}